$.fn.extend({
    trimNewsAnons: function (params) {
        var items = $(this);
        items.each(function (i, li) {

            var span_exactly=$(li).find('span.exactly');
            var title=$(li).find('span.title');
            var anons=$(li).find('span.news_anons');
            ht0=parseInt($(title).css('line-height'));
            ha0=parseInt($(anons).css('line-height'));
            
            while($(title).height()+$(anons).height() > $(span_exactly).height()){
                var ht=$(title).height();
                var ha=$(anons).height();
                var rowst=ht/ht0;
                var rowsa=ha/ha0;
                var rows=rowst+rowsa;


                if(rowst > rowsa){
                    var span=title;
                    var h0=ht0;
                    var rows0=rowst;
                }else{
                    var span=anons;
                    var h0=ha0;
                    var rows0=rowsa;
                }
                text=$(span).text().split(' ');
                do{
                    text.pop();
                    newtext=text.join(' ')+' ...';
                    $(span).text(newtext);
                }while($(span).height()/h0>=rows0)
            }
        })
    }
});
